<template>
    <div>
        <v-card class="mt-3 mb-0 mx-4 pa-3 py-2">
            <v-layout row>
                <div style="width: 33%">
                    <v-layout row class="title mb-2">
                        <div class="font-weight-medium width-200">
                            Distribution Name:
                        </div>
                        <div class="font-weight-light">
                            {{ distributionName }}
                        </div>
                    </v-layout>
                    <v-layout row class="title">
                        <div class="font-weight-medium width-200">
                            Route:
                        </div>
                        <div class="font-weight-light">{{ route }}</div>
                    </v-layout>
                </div>
                <div style="width: 33%">
                    <v-layout row class="title mb-2">
                        <div class="font-weight-medium width-150">
                            Families:
                        </div>
                        <div class="font-weight-light">
                            {{ routeInfo.families }}
                        </div>
                    </v-layout>
                    <v-layout row class="title">
                        <div class="font-weight-medium width-150">
                            Last Scan:
                        </div>
                        <div class="font-weight-light">
                            {{ routeInfo.lastScanDate | time }}
                        </div>
                    </v-layout>
                </div>
                <div style="width: 33%">
                    <v-layout row class="title mb-2">
                        <div class="font-weight-medium width-200">
                            Scanned Boxes:
                        </div>
                        <div class="font-weight-light">
                            {{ routeInfo.scannedBoxes }}
                        </div>
                    </v-layout>
                    <v-layout row class="title">
                        <div class="font-weight-medium width-200">
                            UnScanned Boxes:
                        </div>
                        <div class="font-weight-light">
                            {{ routeInfo.unScannedBoxes }}
                        </div>
                    </v-layout>
                </div>
            </v-layout>
        </v-card>
        <dx-grid
            :url="url"
            :columns="columns"
            :title="title"
            :actions="actions"
            :onLoaded="onLoaded"
            :beforeSetupGrid="beforeSetupGrid"
            :onRowClicked="onRowClicked"
            navigationPath="onRowClicked"
            navigationField="onRowClicked"
            :selectionEnabled="true"
            ref="grid"
        ></dx-grid>
        <v-dialog persistent v-model="updateBoxesDialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >Update Boxes</v-card-title
                >
                <v-select
                    class="mb-0 mx-1"
                    label="Routes"
                    ref="boxesRoute"
                    :items="routes"
                    :rules="[rules.required]"
                    v-model="updateBoxes.route"
                ></v-select>
                <v-text-field
                    class="mb-0 mx-1"
                    label="Truck"
                    ref="boxesTruck"
                    :rules="[rules.required]"
                    v-model="updateBoxes.truck"
                ></v-text-field>
                <v-text-field
                    class="mb-0 mx-1"
                    label="Label Batch"
                    ref="boxesLabelBatch"
                    v-model="updateBoxes.labelBatch"
                ></v-text-field>
                <v-menu
                    v-model="updateBoxes.datePickerMenu"
                    :close-on-content-click="true"
                    offset-y
                    full-width
                    prepend-icon="mdi-currency-usd"
                >
                    <template v-slot:activator="{ on }">
                        <v-text-field
                            class="mb-4 mx-1"
                            hide-details
                            v-model="updateBoxes.scheduledDeliveryDate"
                            :value="updateBoxes.scheduledDeliveryDate"
                            label="Delivery Date"
                            prepend-icon="mdi-calendar"
                            ref="boxesDeliveryDate"
                            readonly
                            v-on="on"
                        ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="updateBoxes.scheduledDeliveryDate"
                    ></v-date-picker>
                </v-menu>
                <v-card-actions class="mr-0 mt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="
                            updateBoxesDialog = false;
                            updateBoxes.datePickerMenu = false;
                        "
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="saveBoxes"
                    >
                        Save Boxes
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog persistent v-model="deleteBoxesDialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >Delete Boxes</v-card-title
                >
                <div class="font-weight-regular">
                    {{ selectedRows.length }} boxes will be deleted
                </div>
                <v-card-actions class="mr-0 mt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="deleteBoxesDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="deleteBoxes"
                    >
                        Delete Boxes
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog persistent v-model="updateBoxDialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >Update Box</v-card-title
                >
                <div class="mb-3 pa-2" style="border: 2px solid #4caf50">
                    <div>
                        {{ rowClicked.firstName + " " + rowClicked.lastName }}
                    </div>
                    <div>{{ rowClicked.homePhone }}</div>
                </div>

                <v-text-field
                    class="mb-2"
                    label="Address"
                    v-model="rowClicked.address"
                    :rules="[rules.required]"
                    ref="address"
                ></v-text-field>
                <v-text-field
                    class="mb-0 mx-1"
                    label="House"
                    ref="house"
                    :rules="[rules.required]"
                    v-model="rowClicked.house"
                ></v-text-field>
                <v-text-field
                    class="mb-0 mx-1"
                    label="Street"
                    ref="street"
                    :rules="[rules.required]"
                    v-model="rowClicked.street"
                ></v-text-field>
                <v-select
                    class="mb-0 mx-1"
                    label="Routes"
                    ref="route"
                    :items="routes"
                    :rules="[rules.required]"
                    v-model="rowClicked.route"
                ></v-select>
                <v-text-field
                    class="mb-0 mx-1"
                    label="Sort"
                    ref="sort"
                    :rules="[rules.required]"
                    v-model="rowClicked.sort"
                ></v-text-field>
                <v-text-field
                    class="mb-0 mx-1"
                    label="Truck"
                    ref="truck"
                    :rules="[rules.required]"
                    v-model="rowClicked.truck"
                ></v-text-field>
                <v-text-field
                    class="mb-0 mx-1"
                    label="Label Batch"
                    ref="labelBatch"
                    v-model="rowClicked.labelBatch"
                ></v-text-field>
                <v-menu
                    v-model="rowClicked.datePickerMenu"
                    :close-on-content-click="true"
                    offset-y
                    full-width
                    prepend-icon="mdi-currency-usd"
                >
                    <template v-slot:activator="{ on }">
                        <v-text-field
                            class="mb-3 mx-1"
                            hide-details
                            v-model="rowClicked.scheduledDeliveryDate"
                            :value="rowClicked.scheduledDeliveryDate"
                            label="Delivery Date"
                            prepend-icon="mdi-calendar"
                            ref="deliveryDate"
                            readonly
                            v-on="on"
                        ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="rowClicked.scheduledDeliveryDate"
                    ></v-date-picker>
                </v-menu>
                <v-card-actions class="mr-0 mt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="
                            updateBoxDialog = false;
                            rowClicked.datePickerMenu = false;
                        "
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="saveBox"
                    >
                        Save Box
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog persistent v-model="notificationDialog" max-width="1200">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >Broadcast Notification</v-card-title
                >
                <div class="font-weight-regular">
                    {{ getSelectedFamilyIDs().length }} families will be
                    notified
                </div>

                <v-layout row class="my-3">
                    <v-flex xs7 column>
                        <div class="headline mb-3">Call Setup</div>
                        <v-divider class="pb-2"></v-divider>
                        <div
                            v-for="(instruction,
                            index) in notification.callInstructions"
                        >
                            <v-layout row>
                                <v-select
                                    style="max-width: 120px"
                                    label="Type"
                                    hide-details
                                    class="mr-2"
                                    :items="['Audio', 'Text', 'Data Field']"
                                    v-model="instruction.type"
                                ></v-select>

                                <v-select
                                    label="Data Field"
                                    v-if="instruction.type == 'Data Field'"
                                    class="mr-2"
                                    :items="getBoxFields()"
                                    v-model="instruction.dataField"
                                ></v-select>

                                <v-text-field
                                    class="mr-2 width-200"
                                    v-if="instruction.type == 'Audio'"
                                    label="Audio URL"
                                    v-model="instruction.audioURL"
                                    ref="audioURL"
                                ></v-text-field>
                                <audio
                                    controls
                                    v-if="instruction.type == 'Audio'"
                                    style="height: 33px"
                                    class="mt-3"
                                    :src="instruction.audioURL"
                                ></audio>

                                <v-textarea
                                    class="pt-0"
                                    v-if="instruction.type == 'Text'"
                                    label="Text"
                                    v-model="instruction.text"
                                    ref="callText"
                                    rows="2"
                                ></v-textarea>

                                <v-btn
                                    class="mb-0"
                                    @click="addInstruction('call')"
                                    flat
                                    icon
                                    color="success"
                                >
                                    <v-icon>mdi-plus-circle</v-icon>
                                </v-btn>
                                <v-btn
                                    class="mb-0"
                                    :disabled="index == 0"
                                    @click="removeInstruction('call', index)"
                                    flat
                                    icon
                                    color="#f55a4e"
                                >
                                    <v-icon>mdi-minus-circle-outline</v-icon>
                                </v-btn>
                            </v-layout>
                        </div>
                    </v-flex>
                    <v-divider vertical></v-divider>
                    <v-flex xs5 column>
                        <div class="headline mb-3">SMS Setup</div>
                        <v-divider class="pb-2"></v-divider>
                        <div
                            v-for="(instruction,
                            index) in notification.textInstructions"
                        >
                            <v-layout row>
                                <v-select
                                    style="max-width: 120px"
                                    label="Type"
                                    hide-details
                                    class="mr-2"
                                    :items="['Audio', 'Text', 'Data Field']"
                                    v-model="instruction.type"
                                ></v-select>

                                <v-select
                                    label="Data Field"
                                    v-if="instruction.type == 'Data Field'"
                                    class="mr-2"
                                    :items="getBoxFields()"
                                    v-model="instruction.dataField"
                                ></v-select>

                                <v-textarea
                                    class="pt-0"
                                    v-if="instruction.type == 'Text'"
                                    label="Text"
                                    v-model="instruction.text"
                                    ref="callText"
                                    rows="2"
                                ></v-textarea>

                                <v-btn
                                    class="mb-0"
                                    @click="addInstruction('sms')"
                                    flat
                                    icon
                                    color="success"
                                >
                                    <v-icon>mdi-plus-circle</v-icon>
                                </v-btn>
                                <v-btn
                                    class="mb-0"
                                    :disabled="index == 0"
                                    @click="removeInstruction('sms', index)"
                                    flat
                                    icon
                                    color="#f55a4e"
                                >
                                    <v-icon>mdi-minus-circle-outline</v-icon>
                                </v-btn>
                            </v-layout>
                        </div>
                    </v-flex>
                </v-layout>

                <v-card-actions class="mr-0 mt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="notificationDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="sendNotification"
                    >
                        Send Notification
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import moment from "moment";
import {
    formatPhoneNumber,
    toISOLocal,
    groupBy,
    toTitleCase,
} from "../../utils/helpers.js";
import XLSX from "xlsx";

export default {
    data: () => ({
        title: "Boxes",

        today: moment().format("YYYY-MM-DD HH:mm:ss"),

        actions: [],
        processing: false,
        route: "",
        routeInfo: "",
        distributionName: "",

        selectedDistribution: "",
        url: "",

        distributions: [],
        routes: [],

        selectedRows: [],

        updateBoxesDialog: false,
        deleteBoxesDialog: false,
        updateBoxDialog: false,
        notificationDialog: false,

        rowClicked: "",

        updateBoxes: {
            route: "",
            truck: "",
            labelBatch: "",
            datePickerMenu: false,
            scheduledDeliveryDate: "",
        },

        notification: {
            callInstructions: [
                {
                    audioURL: "",
                    dataField: "",
                    text: "",
                    type: "Audio",
                },
            ],
            textInstructions: [
                {
                    dataField: "",
                    text: "",
                    type: "Text",
                },
            ],
        },

        rules: {
            required: (v) => {
                return !!v || "Required";
            },
        },

        columns: [
            // {
            //     label: "Boxes Created Date",
            //     field: "boxesCreatedDate",
            //     type: "date",
            //     format: "MM/dd/yyyy hh:mm:ss a",
            //     visible: true,
            //     sortOrder: "desc",
            //     sortIndex: 0,
            //     filterValues: [],
            //     filterValue: null,
            //     selectedFilterOperation: null,
            // },
            {
                field: "status",
                isIcon: true,
                template: "icon",
                alignment: "center",
                visible: true,
                allowFiltering: false,
                allowHeaderFiltering: false,
                allowHiding: false,
                allowSearch: false,
                cssClass: "width-25",
                headerFilter: {
                    allowSearch: false,
                    groupInterval: undefined,
                    height: undefined,
                    searchMode: "contains",
                    width: undefined,
                },
                icon: (value, row) => {
                    switch (value) {
                        case "DELIVERED":
                            return "mdi-check-circle";
                        case "NOT DELIVERED":
                            return "mdi-close-circle";
                        case "SCAN DELETED":
                            return "mdi-delete";
                        case "N/A":
                            return "mdi-clock";
                        default:
                            return "";
                    }
                },
                iconColor: (value, row) => {
                    switch (value) {
                        case "DELIVERED":
                            return "success";
                        case "NOT DELIVERED":
                            return "#f35123";
                        case "SCAN DELETED":
                            return "#aeb8bf";
                        case "N/A":
                            return "#fdb400";
                        default:
                            return "";
                    }
                },
            },
            {
                label: "Family ID",
                field: "familyID",
                visible: true,
                link: "FoodDistributionFamilyView",
                format: "",
                template: "link-cell-template",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "First Name",
                field: "firstName",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Last Name",
                field: "lastName",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Name",
                field: "fullName",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Address",
                field: "address",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Truck",
                field: "truck",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Home Phone",
                field: "homePhone",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Cell Phone",
                field: "cellPhone",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Box Number",
                field: "boxNum",
                visible: true,
                type: "number",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Of Boxes",
                field: "ofBoxes",
                type: "number",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Red",
                field: "red",
                visible: true,
                type: "number",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Blue",
                field: "blue",
                visible: true,
                type: "number",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Green",
                field: "green",
                visible: true,
                type: "number",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Yellow",
                field: "yellow",
                visible: true,
                type: "number",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Box Size",
                field: "boxSize",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Sort",
                field: "sort",
                visible: true,
                filterValues: [],
                sortOrder: "asc",
                sortIndex: 0,
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Label Batch",
                field: "labelBatch",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Date Created",
                field: "dateCreated",
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Scheduled Delivery Date",
                field: "scheduledDeliveryDate",
                type: "date",
                format: "MM/dd/yyyy",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Status",
                field: "status",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Scan Date",
                field: "scanDate",
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Alerted Date",
                field: "alertedDate",
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Street",
                field: "street",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "House",
                field: "house",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Street Side",
                field: "streetSide",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Bus Apt",
                field: "busApt",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Bus State",
                field: "busState",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Box Note",
                field: "boxNote",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Scanned By",
                field: "user",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],
    }),
    async created() {},
    mounted() {},
    methods: {
        async beforeSetupGrid() {
            this.url =
                "foodDistributionBoxes?distributionID=" +
                this.$route.query.distributionID +
                "&route=" +
                this.$route.query.route +
                "&scheduledDeliveryDate=" +
                this.$route.query.scheduledDeliveryDate;

            //await this.loadDistributions();
            await this.loadRoutes();
            await this.loadRouteInfo();

            this.addActions();
            this.setupFilter();
        },
        async loadDistributions() {
            const response = await this.$http.get(
                "odata/foodWeeklyDistributions?$filter=not (isCompleted eq true)"
            );

            this.distributions = response.value;
        },
        async loadRoutes() {
            const routes = await this.$http.get(
                "api/foodDistributionRoutes/getRouteNames"
            );

            this.routes = routes.filter(Boolean);
        },
        async loadRouteInfo() {
            const route = await this.$http.get(
                "api/foodDistributionRoutes/getRoute?route=" +
                    this.$route.query.route +
                    "&distributionID=" +
                    this.$route.query.distributionID +
                    "&scheduledDeliveryDate=" +
                    this.$route.query.scheduledDeliveryDate
            );

            this.routeInfo = route;
        },
        addActions() {
            // this.actions.push({
            //     text: "Send Notification",
            //     action: this.openNotificationDialog,
            //     showOnSelection: true,
            // });

            this.actions.push({
                text: "Print Labels",
                action: this.printLabels,
                showOnSelection: true,
            });

            this.actions.push({
                text: "Update Boxes",
                action: this.openUpdateBoxesDialog,
                showOnSelection: true,
            });

            this.actions.push({
                text: "Delete Boxes",
                action: this.openDeleteBoxesDialog,
                showOnSelection: true,
            });
        },
        setupFilter() {
            this.resetStatusFilter();

            const filter = this.$route.query.filter;

            if (!filter) return;

            const column = this.columns.find(
                (c) => c.field == "status" && !c.isIcon
            );

            if (filter == "unScannedBoxes") {
                column.filterValue = "N/A";
                column.selectedFilterOperation = "=";
            } else if (filter == "scannedBoxes") {
                column.filterValue = "DELIVERED";
                column.selectedFilterOperation = "";
            } else if (filter == "unDelivered") {
                column.filterValue = "DELIVERED";
                column.selectedFilterOperation = "<>";
            }
        },
        resetStatusFilter() {
            const url = this.url.split("?");

            let state = localStorage.getItem(url[0]);

            if (state) {
                state = JSON.parse(state);

                const statusColumns = state.columns.filter(
                    (c) => c.dataField == "status"
                );

                statusColumns.forEach((column) => {
                    column.filterValue = "";
                    column.filterValues = [];
                    column.selectedFilterOperation = null;
                });

                localStorage.setItem(url[0], JSON.stringify(state));
            }
        },
        onRowClicked(row) {
            this.rowClicked = JSON.parse(JSON.stringify(row));
            this.rowClicked.datePickerMenu = false;
            this.rowClicked.scheduledDeliveryDate = toISOLocal(
                new Date(this.rowClicked.scheduledDeliveryDate)
            ).substr(0, 10);

            this.updateBoxDialog = true;
        },
        onLoaded(data) {
            if (!data.length) return;

            this.route = data[0].route;
            this.distributionName = data[0].distributionName;

            this.updateBoxes.route = this.route;
            this.updateBoxes.scheduledDeliveryDate = toISOLocal(
                new Date(data[0].scheduledDeliveryDate)
            ).substr(0, 10);
            //this.updateBoxes.truck = data[0].truck;

            data.forEach(
                (d) => (d.sort = d.sort ? d.sort.replace(/^0+/, "") : "")
            );
        },
        openNotificationDialog() {
            this.notificationDialog = true;
            this.selectedRows = JSON.parse(
                JSON.stringify(this.$refs.grid.getSelectedRowsData())
            );
        },
        openUpdateBoxesDialog() {
            this.updateBoxesDialog = true;
            this.selectedRows = JSON.parse(
                JSON.stringify(this.$refs.grid.getSelectedRowsData())
            );
        },
        openDeleteBoxesDialog() {
            this.deleteBoxesDialog = true;
            this.selectedRows = JSON.parse(
                JSON.stringify(this.$refs.grid.getSelectedRowsData())
            );
        },
        getBoxFields() {
            const box = this.selectedRows[0];

            return Object.keys(box)
                .map((b) => toTitleCase(b))
                .sort();
        },
        async saveBox() {
            if (
                !this.$refs.address.validate(true) ||
                !this.$refs.route.validate(true) ||
                !this.$refs.sort.validate(true) ||
                !this.$refs.truck.validate(true) ||
                !this.$refs.deliveryDate.validate(true) ||
                !this.$refs.house.validate(true) ||
                !this.$refs.street.validate(true)
            )
                return;

            try {
                this.processing = true;

                await this.$http.post("api/foodDistributionBoxes/updateBox", {
                    boxID: this.rowClicked.boxID,
                    address: this.rowClicked.address,
                    route: this.rowClicked.route,
                    sort: this.rowClicked.sort,
                    labelBatch: this.rowClicked.labelBatch,
                    street: this.rowClicked.street,
                    house: this.rowClicked.house,
                    truck: this.rowClicked.truck,
                    scheduledDeliveryDate: this.rowClicked
                        .scheduledDeliveryDate,
                });

                this.processing = false;
                this.updateBoxDialog = false;

                this.$notify({
                    group: "notification",
                    text: "Box Updated",
                    type: "success",
                });

                this.$refs.grid.reloadGrid();
            } catch (e) {
                this.processing = false;
            }
        },
        async deleteBoxes() {
            try {
                const ids = this.selectedRows.map((s) => s.boxID);

                this.processing = true;

                await this.$http.post("api/foodDistributionBoxes/deleteBoxes", {
                    boxIDs: ids,
                    //user: this.user
                });

                this.processing = false;
                this.deleteBoxesDialog = false;

                this.$notify({
                    group: "notification",
                    text: ids.length + " Boxes Deleted",
                    type: "success",
                });

                this.$refs.grid.reloadGrid();
            } catch (e) {
                this.processing = false;
            }
        },
        async saveBoxes() {
            try {
                if (
                    !this.$refs.boxesRoute.validate(true) ||
                    !this.$refs.boxesTruck.validate(true) ||
                    !this.$refs.boxesDeliveryDate.validate(true)
                )
                    return;

                const ids = this.selectedRows.map((s) => s.boxID);

                this.processing = true;

                await this.$http.post("api/foodDistributionBoxes/updateBoxes", {
                    boxIDs: ids,
                    route: this.updateBoxes.route,
                    truck: this.updateBoxes.truck,
                    labelBatch: this.updateBoxes.labelBatch,
                    scheduledDeliveryDate: this.updateBoxes
                        .scheduledDeliveryDate,
                });

                this.processing = false;
                this.updateBoxesDialog = false;

                this.$notify({
                    group: "notification",
                    text: "Boxes Updated",
                    type: "success",
                });

                this.$refs.grid.reloadGrid();
            } catch (e) {
                this.processing = false;
            }
        },
        async printLabels() {
            var grid = this.$refs.grid;

            const sortOptions = grid.dataSource.loadOptions().sort.length
                ? grid.dataSource.loadOptions().sort[0]
                : "";

            const selected = grid.getSelectedRowsData();

            const sort = sortOptions
                ? sortOptions.selector +
                  " " +
                  (sortOptions.desc ? "desc" : "asc")
                : "";

            const ids = selected.map((d) => d.boxID);

            try {
                const response = await this.$http({
                    url: "api/foodDistributionBoxes/printLables",
                    method: "POST",
                    data: { selectedIDs: ids, orderBy: sort },
                    responseType: "blob",
                });

                const url = window.URL.createObjectURL(new Blob([response]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "BoxesLabels.pdf");
                document.body.appendChild(link);
                link.click();
            } catch (e) {}
        },
        addInstruction(type) {
            if (type == "call") {
                this.notification.callInstructions.push({
                    audioURL: "",
                    dataField: "",
                    text: "",
                    type: "Audio",
                });
            } else {
                this.notification.textInstructions.push({
                    dataField: "",
                    text: "",
                    type: "Text",
                });
            }

            this.$forceUpdate();
        },
        removeInstruction(type, index) {
            if (type == "call") {
                this.notification.callInstructions.splice(index, 1);
            } else {
                this.notification.textInstructions.splice(index, 1);
            }

            this.$forceUpdate();
        },
        getSelectedFamilyIDs() {
            if (!this.selectedRows) return [];

            const group = groupBy(this.selectedRows, "familyID");

            const familyIDs = [];

            Object.keys(group).forEach((key) => {
                familyIDs.push(key);
            });

            return familyIDs;
        },
        async sendNotification() {
            try {
                // if (
                //     !this.$refs.boxesRoute.validate(true)
                // )
                //     return;

                const ids = this.selectedRows.map((s) => s.boxID);

                this.processing = true;

                // const textInstructions = this.notification.textInstructions.map(instruction => {
                //     if (instruction.dataField) {
                //         instruction.text =
                //     }

                //     return instruction;
                // });

                const distributionID = this.selectedRows[0].distributionID;

                await this.$http.post(
                    "api/foodDistributionAccountInfo/Broadcast",
                    {
                        user: this.$store.state.authentication.user,
                        distributionID: distributionID,
                        familyIDs: this.getSelectedFamilyIDs(),
                        callInstructions: this.notification.callInstructions,
                        textInstructions: this.notification.textInstructions,
                    }
                );

                this.processing = false;
                this.notificationDialog = false;

                this.$notify({
                    group: "notification",
                    text: "Notification Sent",
                    type: "success",
                });

                this.$refs.grid.reloadGrid();
            } catch (e) {
                this.processing = false;
            }
        },
    },
};
</script>
